(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digame-social"] && !Shopify.designMode) return;
  try {
    
class DigameDeck {
  constructor(bank, history = {}, random = Math.random) {
    this.bank = bank;
    this.random = random;
    this.used = {};
    for (const [die, faces] of Object.entries(bank)) {
      for (const [face, pool] of Object.entries(faces)) {
        const key = `${die}:${face}`;
        this.used[key] = Array.isArray(history[key]) ? [...new Set(history[key].filter(i => Number.isInteger(i) && i >= 0 && i < pool.length))] : [];
      }
    }
  }
  draw(die, face) {
    const pool = this.bank[die]?.[face];
    if (!pool?.length) throw new Error('Unknown die or face');
    const key = `${die}:${face}`;
    let used = this.used[key];
    const previous = used.at(-1);
    let available = pool.map((_, i) => i).filter(i => !used.includes(i));
    if (!available.length) {
      used = this.used[key] = [];
      available = pool.map((_, i) => i).filter(i => pool.length === 1 || i !== previous);
    }
    const index = available[Math.min(available.length - 1, Math.floor(this.random() * available.length))];
    used.push(index);
    return { die, face: Number(face), index, text: pool[index] };
  }
}

class OkeyDigameSocial extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.words = this.config.words;
    this.stage = this.querySelector('[data-stage]');
    this.stageHome = this.querySelector('[data-stage-slot]');
    this.dialog = this.querySelector('dialog');
    this.key = `okeydice:digame:social-v1:${this.config.language}`;
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(this.key)) || {}; } catch {}
    this.deck = new DigameDeck(this.config.bank, saved.used);
    this.state = { screen: 'dice', die: null, face: null, index: null };
    if (saved.state && ['dice', 'faces', 'challenge'].includes(saved.state.screen)) {
      const s = saved.state;
      if (s.screen === 'dice' || this.config.bank[s.die]) {
        this.state = { screen: s.screen, die: s.die, face: s.face, index: s.index };
        if (s.screen === 'challenge' && !this.config.bank[s.die]?.[s.face]?.[s.index]) this.state.screen = 'faces';
      }
    }
    this.abort = new AbortController();
    this.addEventListener('click', e => this.handle(e), { signal: this.abort.signal });
    this.dialog.addEventListener('close', () => {
      this.stageHome.append(this.stage);
      document.body.style.overflow = this.oldOverflow ?? '';
      this.render();
      this.stage.querySelector('[data-action="focus"]')?.focus({ preventScroll: true });
    }, { signal: this.abort.signal });
    this.previewIndex = 0;
    this.render();
  }
  disconnectedCallback() {
    this.abort?.abort();
    if (this.dialog?.open) {
      this.dialog.close();
      this.stageHome.append(this.stage);
      document.body.style.overflow = this.oldOverflow ?? '';
    }
    this.ready = false;
  }
  button(label, action, className = 'dg2-btn', extra = {}) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = className;
    b.textContent = label;
    b.dataset.action = action;
    Object.assign(b.dataset, extra);
    return b;
  }
  text(tag, value, className = '') {
    const el = document.createElement(tag);
    el.textContent = this.config.language === 'fr' ? value.replace(/ (?=[?!;:])/g, '\u00a0') : value;
    el.className = className;
    return el;
  }
  image(url) {
    const img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.width = 180;
    img.height = 180;
    img.loading = 'eager';
    return img;
  }
  save() {
    try { sessionStorage.setItem(this.key, JSON.stringify({ used: this.deck.used, state: this.state })); } catch {}
  }
  focusHeading() {
    this.stage.querySelector('h3')?.focus({ preventScroll: true });
  }
  render(focus = false) {
    const w = this.words, s = this.state;
    this.stage.replaceChildren();
    this.stage.dataset.screen = s.screen;
    const top = this.text('div', '', 'dg2-stage-top');
    top.append(this.text('span', w.table, 'dg2-mono'));
    top.append(this.button(this.dialog.open ? w.close : w.focus, this.dialog.open ? 'close' : 'focus', 'dg2-small'));
    this.stage.append(top);
    const trail = this.text('nav', '', 'dg2-trail');
    trail.setAttribute('aria-label', w.progress);
    const steps = [[w.dieStep, 'dice'], [w.faceStep, 'faces'], [w.challengeStep, 'challenge']];
    steps.forEach(([label, screen], i) => {
      const current = s.screen === screen;
      const canBack = screen === 'dice' || (screen === 'faces' && s.die);
      const el = canBack ? this.button(`${i + 1}. ${label}`, screen, 'dg2-trail-item') : this.text('span', `${i + 1}. ${label}`, 'dg2-trail-item');
      if (current) el.setAttribute('aria-current', 'step');
      trail.append(el);
    });
    this.stage.append(trail);
    const body = this.text('div', '', 'dg2-stage-body');
    const heading = this.text('h3', s.screen === 'dice' ? w.chooseDie : s.screen === 'faces' ? w.chooseFace : w.readAloud);
    heading.tabIndex = -1;
    body.append(heading);
    if (s.screen === 'dice') {
      body.append(this.text('p', w.dieHelp, 'dg2-stage-help'));
      const grid = this.text('div', '', 'dg2-dice');
      Object.entries(this.config.dice).forEach(([key, die]) => {
        const b = this.button('', 'pickDie', 'dg2-die', { die: key });
        b.append(this.image(die.image), this.text('span', die.name), this.text('small', die.hint));
        grid.append(b);
      });
      body.append(grid);
      body.append(this.text('p', w.physical, 'dg2-stage-foot'));
    } else if (s.screen === 'faces') {
      const die = this.config.dice[s.die];
      body.append(this.text('p', `${die.name} · ${w.faceHelp}`, 'dg2-stage-help'));
      const grid = this.text('div', '', 'dg2-faces');
      grid.dataset.count = die.faces.length;
      die.faces.forEach((face, index) => {
        const b = this.button('', 'pickFace', 'dg2-face', { face: String(index) });
        b.append(this.image(face.image), this.text('span', face.name));
        grid.append(b);
      });
      body.append(grid);
    } else {
      const die = this.config.dice[s.die];
      const card = this.text('div', '', 'dg2-challenge');
      card.append(this.text('span', `${die.name} / ${die.faces[s.face].name}`, 'dg2-mono'));
      const challenge = this.text('p', this.config.bank[s.die][s.face][s.index], 'dg2-challenge-text');
      challenge.setAttribute('aria-live', 'polite');
      challenge.setAttribute('aria-atomic', 'true');
      card.append(challenge);
      card.append(this.text('span', 'DIGA’ME', 'dg2-card-signature'));
      body.append(card);
      const actions = this.text('div', '', 'dg2-actions');
      actions.append(this.button(w.next, 'next', 'dg2-btn dg2-green'), this.button(w.another, 'another', 'dg2-btn dg2-ghost'));
      body.append(actions, this.text('p', w.pass, 'dg2-stage-foot'));
    }
    this.stage.append(body);
    this.save();
    if (focus) this.focusHeading();
  }
  handle(event) {
    const button = event.target.closest('[data-action]');
    if (!button || !this.contains(button)) return;
    const action = button.dataset.action;
    if (action === 'rules') {
      event.preventDefault();
      const details = this.querySelector('details');
      details.open = true;
      details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      details.querySelector('summary').focus({ preventScroll: true });
      return;
    }
    if (action === 'start') {
      this.querySelector('[data-game]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      this.focusHeading();
      return;
    }
    if (action === 'preview') {
      this.previewIndex = (this.previewIndex + 1) % this.config.previews.length;
      const p = this.config.previews[this.previewIndex];
      this.querySelector('[data-preview-label]').textContent = p.label;
      this.querySelector('[data-preview-text]').textContent = p.text;
      return;
    }
    if (action === 'focus') {
      this.oldOverflow = document.body.style.overflow;
      this.dialog.append(this.stage);
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.render(true);
      return;
    }
    if (action === 'close') {
      this.dialog.close();
      this.render();
      return;
    }
    if (action === 'pickDie') this.state = { screen: 'faces', die: button.dataset.die, face: null, index: null };
    if (action === 'pickFace') {
      const q = this.deck.draw(this.state.die, Number(button.dataset.face));
      this.state = { screen: 'challenge', die: q.die, face: q.face, index: q.index };
    }
    if (action === 'another' && this.state.screen === 'challenge') {
      const q = this.deck.draw(this.state.die, this.state.face);
      this.state.index = q.index;
    }
    if (action === 'next' || action === 'dice') this.state = { screen: 'dice', die: null, face: null, index: null };
    if (action === 'faces' && this.state.die) this.state = { ...this.state, screen: 'faces', face: null, index: null };
    this.render(true);
  }
}
if (!customElements.get('okey-digame-social')) customElements.define('okey-digame-social', OkeyDigameSocial);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-dice-simulator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-dice-simulator')) {
  customElements.define('okd-dice-simulator', class extends HTMLElement {
    static viewerPromise;
    static loadViewer() {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (this.viewerPromise) return this.viewerPromise;
      this.viewerPromise = new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('3D unavailable')), 15000);
        const finish = error => {
          if (error) { clearTimeout(timeout); reject(error); return; }
          customElements.whenDefined('model-viewer').then(() => { clearTimeout(timeout); resolve(); });
        };
        if (!window.Shopify?.loadFeatures) { clearTimeout(timeout); reject(new Error('3D unavailable')); return; }
        window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: finish }]);
      });
      return this.viewerPromise;
    }
    connectedCallback() {
      if (this.controller) return;
      const configElement = this.querySelector('[data-simulator-config]');
      if (!configElement) return;
      this.config = JSON.parse(configElement.textContent);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panels = Array.from(this.querySelectorAll('[data-die-panel]'));
      this.buttons = Array.from(this.querySelectorAll('[data-select-die]'));
      this.dice = new Map(this.panels.map(panel => [panel.dataset.diePanel, JSON.parse(panel.querySelector('[data-die-config]').textContent)]));
      this.pose = [0, 0, 0];
      this.setupBackdrops();
      this.modelToken = this.modelToken || 0;
      this.modelReady = false;
      this.hasResult = false;
      this.hasUserInteracted = false;
      this.setupSound(signal);
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionQuery.addEventListener('change', () => this.updateIdle(), { signal });
      document.addEventListener('visibilitychange', () => this.updateIdle(), { signal });
      const tabs = this.querySelector('.okds-tabs');
      if (tabs) tabs.hidden = false;
      this.style.setProperty('--tab-count', Math.max(1, this.panels.length));
      this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button.dataset.selectDie), { signal }));
      this.panels.forEach(panel => {
        const roll = panel.querySelector('[data-roll]');
        roll.hidden = false;
        roll.addEventListener('click', () => this.roll(panel), { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        if (this.dice.has(id)) this.choose(id);
      }, { signal });
      if (this.panels.length) this.choose(this.panels[0].dataset.diePanel);
      this.classList.add('okds-colors-ready');
      this.setupVideo(signal);
      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(entries => {
          this.nearViewport = entries.some(entry => entry.isIntersecting);
          if (this.nearViewport) this.mountModel();
        }, { rootMargin: '180px' });
        this.viewportObserver.observe(this);
        this.idleObserver = new IntersectionObserver(entries => {
          const stage = this.panels.find(panel => panel.dataset.diePanel === this.activeId)?.querySelector('[data-die-stage]');
          const entry = entries.find(item => item.target === stage);
          if (!entry) return;
          this.visibleInViewport = entry.isIntersecting;
          this.updateIdle();
        });
        const stage = this.panels[0]?.querySelector('[data-die-stage]');
        if (stage) this.idleObserver.observe(stage);
      } else {
        this.nearViewport = true;
        this.visibleInViewport = true;
        this.mountModel();
      }
    }
    disconnectedCallback() {
      this.cancelRoll();
      this.disposeSound();
      this.releaseModel();
      clearTimeout(this.backdropTimer);
      this.querySelectorAll('[data-section-backdrops], [data-container-backdrops]').forEach(group => group.replaceChildren());
      this.classList.remove('okds-colors-ready');
      this.viewportObserver?.disconnect();
      this.idleObserver?.disconnect();
      this.viewportObserver = null;
      this.idleObserver = null;
      this.visibleInViewport = false;
      this.controller?.abort();
      this.controller = null;
      if (this.video) this.video.pause();
      if (this.dialog?.open) this.dialog.close();
    }
    cancelRoll() {
      this.stopIdle();
      this.stopSounds();
      this.rollToken = (this.rollToken || 0) + 1;
      clearTimeout(this.rollTimer);
      cancelAnimationFrame(this.rollFrame);
      this.panels?.forEach(panel => {
        panel.querySelector('[data-roll]').disabled = false;
        panel.querySelector('[data-die-image]').classList.remove('is-rolling');
        panel.querySelector('[data-die-stage]').style.removeProperty('transform');
      });
    }
    releaseModel() {
      this.stopIdle();
      this.modelToken = (this.modelToken || 0) + 1;
      clearTimeout(this.modelTimer);
      this.modelController?.abort();
      this.modelController = null;
      this.model?.remove();
      this.model = null;
      this.modelReady = false;
      this.modelLoading = false;
      this.panels?.forEach(panel => {
        panel.querySelector('[data-die-stage]').classList.remove('has-model');
        panel.querySelector('[data-drag-hint]').hidden = true;
      });
    }
    setupBackdrops() {
      this.backdropGroups = [
        { element: this.querySelector('[data-section-backdrops]'), key: 'sectionBg' },
        { element: this.querySelector('[data-container-backdrops]'), key: 'containerBg' }
      ];
      this.backdropGroups.forEach(group => {
        if (!group.element) return;
        this.panels.forEach(panel => {
          const layer = document.createElement('span');
          layer.className = 'okds-bg-layer';
          layer.dataset.backdropDie = panel.dataset.diePanel;
          layer.style.background = panel.dataset[group.key] || '';
          group.element.append(layer);
        });
      });
    }
    transitionBackdrops(id, previousId) {
      clearTimeout(this.backdropTimer);
      const animate = previousId && previousId !== id && this.classList.contains('okds-colors-ready') && !this.motionQuery.matches;
      this.backdropGroups.forEach(group => {
        group.element?.querySelectorAll('.okds-bg-layer').forEach(layer => {
          const current = layer.dataset.backdropDie === id;
          const leaving = animate && layer.dataset.backdropDie === previousId;
          layer.classList.toggle('is-active', current);
          layer.classList.toggle('is-leaving', Boolean(leaving));
        });
      });
      if (animate) {
        const duration = Number(this.style.getPropertyValue('--bg-duration').replace('ms', '')) || 550;
        this.backdropTimer = setTimeout(() => {
          this.backdropGroups.forEach(group => group.element?.querySelectorAll('.is-leaving').forEach(layer => layer.classList.remove('is-leaving')));
        }, duration + 50);
      }
    }
    choose(id) {
      const active = this.panels.find(panel => panel.dataset.diePanel === id);
      if (!active) return;
      const previousId = this.activeId;
      this.cancelRoll();
      this.releaseModel();
      this.activeId = id;
      this.resultAlt = null;
      this.hasResult = false;
      active.removeAttribute('data-has-result');
      this.hasUserInteracted = false;
      this.pose = [0, 0, 0];
      this.panels.forEach(panel => {
        const selected = panel === active;
        panel.classList.toggle('is-active', selected);
        panel.inert = !selected;
        panel.setAttribute('aria-hidden', String(!selected));
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectDie === id)));
      this.transitionBackdrops(id, previousId);
      ['heading', 'intro', 'footer', 'emphasis'].forEach(part => {
        const name = `--active-${part}-color`;
        if (active.dataset.customColors === 'true') this.style.setProperty(name, active.dataset[`${part}Color`]);
        else this.style.removeProperty(name);
      });
      const config = this.dice.get(id);
      const image = active.querySelector('[data-die-image]');
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      image.src = reduceMotion ? config.faces[0].image : config.initialImage;
      image.alt = reduceMotion ? config.faces[0].name : config.initialAlt;
      active.querySelector('[data-result]').textContent = this.config.ready;
      this.syncResult(active, false);
      active.querySelector('[data-roll-label]').textContent = this.config.roll;
      if (this.idleObserver) {
        this.visibleInViewport = false;
        this.idleObserver.disconnect();
        this.idleObserver.observe(active.querySelector('[data-die-stage]'));
      }
      if (this.nearViewport) this.mountModel();
    }
    syncResult(panel, hasResult) {
      const result = panel.querySelector('.okds-result');
      const label = panel.querySelector('[data-result]');
      const readyNote = panel.querySelector('[data-ready-note]');
      const resultNote = panel.querySelector('[data-result-note]');
      const hasText = element => Boolean(element.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, ''));
      label.hidden = !hasText(label);
      readyNote.hidden = hasResult || !hasText(readyNote);
      resultNote.hidden = !hasResult || !hasText(resultNote);
      const visibleLabel = !label.hidden && !label.classList.contains('okds-sr-only');
      result.classList.toggle('is-empty', !visibleLabel && readyNote.hidden && resultNote.hidden);
    }
    polishGold(model) {
      model.model?.materials.forEach(material => {
        if (material.name !== 'OkeyDice — or métallique poli') return;
        const surface = material.pbrMetallicRoughness;
        surface.setBaseColorFactor([1, 0.55, 0.055, 1]);
        surface.setMetallicFactor(1);
        surface.setRoughnessFactor(0.13);
      });
    }
    async mountModel() {
      const panel = this.panels.find(item => item.dataset.diePanel === this.activeId);
      const config = this.dice.get(this.activeId);
      if (!panel || config.visualMode !== '3d' || !config.modelUrl || this.model || this.modelLoading) return;
      this.modelLoading = true;
      const token = this.modelToken;
      try {
        await this.constructor.loadViewer();
        if (!this.isConnected || token !== this.modelToken) return;
        const model = document.createElement('model-viewer');
        this.model = model;
        this.modelController = new AbortController();
        const signal = this.modelController.signal;
        model.className = 'okds-model';
        model.setAttribute('alt', this.resultAlt || config.initialAlt);
        model.setAttribute('loading', 'eager');
        model.setAttribute('reveal', 'auto');
        model.setAttribute('camera-orbit', '18deg 72deg 125%');
        model.setAttribute('camera-target', '0m 0m 0m');
        model.setAttribute('field-of-view', '30deg');
        model.setAttribute('min-camera-orbit', 'auto 0deg auto');
        model.setAttribute('max-camera-orbit', 'auto 180deg 125%');
        model.setAttribute('disable-zoom', '');
        model.setAttribute('touch-action', 'none');
        model.setAttribute('aria-label', this.config.viewerLabel);
        model.setAttribute('aria-describedby', panel.querySelector('[data-drag-hint]').id);
        model.setAttribute('shadow-intensity', '0.75');
        model.setAttribute('shadow-softness', '1');
        model.setAttribute('exposure', String(this.config.exposure));
        if (this.config.environmentUrl) {
          let environmentUrl = this.config.environmentUrl;
          try {
            const parsed = new URL(environmentUrl, window.location.href);
            const queryKeys = Array.from(parsed.searchParams.keys());
            if (parsed.hostname === 'cdn.shopify.com' && parsed.pathname.endsWith('.hdr') && queryKeys.length === 1 && queryKeys[0] === 'v') {
              parsed.search = '';
              environmentUrl = parsed.href;
            }
          } catch (_) {}
          model.setAttribute('environment-image', environmentUrl);
        }
        model.setAttribute('interaction-prompt', 'none');
        model.setAttribute('interpolation-decay', '20');
        model.setAttribute('orientation', this.pose.map(value => `${value}deg`).join(' '));
        model.inert = true;
        const interacted = () => {
          if (!this.config.interaction || panel.querySelector('[data-roll]').disabled) return;
          this.hasUserInteracted = true;
          this.stopIdle();
        };
        model.addEventListener('pointerdown', interacted, { signal, capture: true });
        model.addEventListener('keydown', event => {
          if (event.key === 'PageUp' || event.key === 'PageDown') {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) interacted();
        }, { signal, capture: true });
        model.addEventListener('camera-change', event => {
          if (event.detail?.source === 'user-interaction') interacted();
        }, { signal });
        const fail = () => {
          if (token !== this.modelToken) return;
          this.releaseModel();
        };
        model.addEventListener('load', () => {
          if (token !== this.modelToken || !this.isConnected) return;
          clearTimeout(this.modelTimer);
          this.modelLoading = false;
          this.modelReady = true;
          this.polishGold(model);
          this.setPose(this.pose);
          if (!panel.querySelector('[data-roll]').disabled) panel.querySelector('[data-die-stage]').classList.add('has-model');
          this.setInteraction(!panel.querySelector('[data-roll]').disabled);
          this.updateIdle();
        }, { signal, once: true });
        model.addEventListener('error', fail, { signal });
        this.modelTimer = setTimeout(fail, 20000);
        panel.querySelector('[data-die-stage]').append(model);
        model.setAttribute('src', config.modelUrl);
      } catch (_) {
        if (token === this.modelToken) this.releaseModel();
      }
    }
    setInteraction(enabled) {
      if (!this.model) return;
      const allowed = Boolean(enabled && this.config.interaction && this.modelReady);
      this.model.toggleAttribute('camera-controls', allowed);
      this.model.inert = !allowed;
      const panel = this.panels.find(item => item.dataset.diePanel === this.activeId);
      if (panel) {
        const hint = panel.querySelector('[data-drag-hint]');
        hint.hidden = !(this.config.interaction && this.modelReady && panel.querySelector('[data-die-stage]').classList.contains('has-model'));
        hint.classList.toggle('is-waiting', !allowed);
      }
    }
    stopIdle() {
      cancelAnimationFrame(this.idleFrame);
      this.idleFrame = null;
    }
    updateIdle() {
      const canMove = this.isConnected && this.modelReady && !this.hasResult && !this.hasUserInteracted && this.visibleInViewport && !document.hidden && !this.motionQuery.matches && this.config.animation;
      if (!canMove) { this.stopIdle(); return; }
      if (this.idleFrame != null) return;
      let previous = performance.now();
      const frame = now => {
        const elapsed = now - previous;
        if (elapsed >= 1000 / 30) {
          this.setPose([0, 0, (this.pose[2] + Math.min(elapsed, 100) * 0.012) % 360]);
          previous = now;
        }
        this.idleFrame = requestAnimationFrame(frame);
      };
      this.idleFrame = requestAnimationFrame(frame);
    }
    setPose(pose) {
      this.pose = pose;
      if (this.model) this.model.setAttribute('orientation', pose.map(value => `${value}deg`).join(' '));
    }
    targetPose(faceIndex) {
      const poses = [[0, 0, 0], [0, 0, -90], [0, 90, 0], [0, 0, 180], [0, 0, 90], [0, -90, 0]];
      return poses[faceIndex];
    }
    roll(panel) {
      const button = panel.querySelector('[data-roll]');
      if (button.disabled || panel.dataset.diePanel !== this.activeId) return;
      this.stopIdle();
      this.hasResult = true;
      const token = this.rollToken = (this.rollToken || 0) + 1;
      this.setInteraction(false);
      const config = this.dice.get(this.activeId);
      const modelFace = Math.floor(Math.random() * 6);
      const faceIndex = config.modelFaceResults[modelFace];
      const face = config.faces[faceIndex];
      const image = panel.querySelector('[data-die-image]');
      const stage = panel.querySelector('[data-die-stage]');
      const target = this.targetPose(modelFace);
      button.disabled = true;
      panel.querySelector('[data-roll-label]').textContent = this.config.rolling;
      const animate = this.config.animation && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = animate ? (this.modelReady ? 1.25 : 0.55) : 0;
      this.beginRollSound(duration);
      if (this.model) {
        this.model.cameraOrbit = '18deg 72deg 125%';
        this.model.cameraTarget = '0m 0m 0m';
        this.model.fieldOfView = '30deg';
        this.model.jumpCameraToGoal();
      }
      const finish = () => {
        if (!this.isConnected || panel.dataset.diePanel !== this.activeId || token !== this.rollToken) return;
        this.setPose(target);
        stage.style.removeProperty('transform');
        image.src = face.image;
        image.alt = face.name;
        image.classList.remove('is-rolling');
        this.resultAlt = face.name;
        if (this.model) this.model.setAttribute('alt', face.name);
        if (this.modelReady) stage.classList.add('has-model');
        panel.setAttribute('data-has-result', '');
        panel.querySelector('[data-result]').textContent = face.name;
        this.syncResult(panel, true);
        panel.querySelector('[data-roll-label]').textContent = this.config.again;
        button.disabled = false;
        this.setInteraction(true);
        this.finishRollSound();
      };
      if (animate && this.modelReady) {
        const start = this.pose.slice();
        const end = target.map((value, index) => value + (index === 0 ? 360 : 720));
        Promise.resolve(this.model.updateComplete).then(() => {
          if (!this.isConnected || token !== this.rollToken || panel.dataset.diePanel !== this.activeId) return;
          const started = performance.now();
          const frame = now => {
            if (token !== this.rollToken) return;
            const progress = Math.min(1, (now - started) / 1250);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.setPose(start.map((value, index) => value + (end[index] - value) * eased));
            const bounce = Math.sin(progress * Math.PI) * Math.sin(progress * Math.PI * 2.5) * 22;
            stage.style.transform = `translateY(${-Math.abs(bounce)}px)`;
            if (progress < 1) this.rollFrame = requestAnimationFrame(frame);
            else finish();
          };
          this.rollFrame = requestAnimationFrame(frame);
        }).catch(finish);
      } else {
        if (animate) image.classList.add('is-rolling');
        this.rollTimer = setTimeout(finish, animate ? 550 : 0);
      }
    }
    setupSound(signal) {
      this.soundGeneration = this.soundGeneration || 0;
      this.soundNodes = this.soundNodes || new Set();
      this.soundCache = this.soundCache || new Map();
      try { this.soundMuted = localStorage.getItem('okd-dice-muted') === 'true'; }
      catch (_) { this.soundMuted = Boolean(this.soundMuted); }
      this.soundButtons = Array.from(this.querySelectorAll('[data-toggle-sound]'));
      this.updateSoundButtons();
      this.addEventListener('click', event => {
        const button = event.target.closest?.('[data-roll], [data-toggle-sound]');
        if (!event.isTrusted || !button || !this.contains(button) || button.disabled) return;
        const gesture = {};
        this.soundGesture = gesture;
        clearTimeout(this.soundGestureTimer);
        this.soundGestureTimer = setTimeout(() => { if (this.soundGesture === gesture) this.soundGesture = null; }, 0);
      }, { capture: true, signal });
      this.soundButtons.forEach(button => button.addEventListener('click', () => this.toggleSound(), { signal }));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopSounds();
      }, { signal });
    }
    updateSoundButtons() {
      const enabled = Boolean(this.config.soundEnabled);
      const on = enabled && !this.soundMuted;
      const label = on ? this.config.soundOnLabel : this.config.soundOffLabel;
      this.soundButtons?.forEach(button => {
        button.hidden = !enabled;
        button.setAttribute('aria-pressed', String(on));
        if (label) {
          button.setAttribute('aria-label', label);
          const text = button.querySelector('[data-sound-label]');
          if (text) text.textContent = label;
        }
      });
    }
    toggleSound() {
      if (!this.soundGesture || !this.config.soundEnabled || !this.isConnected || document.hidden) return;
      this.soundMuted = !this.soundMuted;
      this.stopSounds();
      try { localStorage.setItem('okd-dice-muted', String(this.soundMuted)); } catch (_) {}
      this.updateSoundButtons();
      if (!this.soundMuted) this.openSoundContext();
      this.soundGesture = null;
    }
    openSoundContext() {
      if (!this.soundGesture || !this.isConnected || document.hidden) return null;
      try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return null;
        if (!this.soundContext || this.soundContext.state === 'closed') {
          this.soundContext = new AudioContextClass();
          this.soundFetchController = new AbortController();
        }
        const context = this.soundContext;
        const ready = context.state === 'running' ? Promise.resolve() : context.resume();
        this.soundContextReady = Promise.resolve(ready).then(() => context.state === 'running', () => false);
        return context;
      } catch (_) { return null; }
    }
    loadSoundBuffer(url, context) {
      if (!url) return Promise.resolve(null);
      if (this.soundCache.has(url)) return this.soundCache.get(url);
      const cache = this.soundCache;
      const pending = fetch(url, { signal: this.soundFetchController.signal })
        .then(response => {
          if (!response.ok) throw new Error('Sound unavailable');
          return response.arrayBuffer();
        })
        .then(data => {
          if (context !== this.soundContext || context.state === 'closed') return null;
          return context.decodeAudioData(data);
        })
        .catch(() => {
          if (cache.get(url) === pending) cache.delete(url);
          return null;
        });
      cache.set(url, pending);
      return pending;
    }
    soundSessionValid(session) {
      return Boolean(session && session === this.soundSession && session.generation === this.soundGeneration &&
        session.context === this.soundContext && this.isConnected && !document.hidden &&
        this.config.soundEnabled && !this.soundMuted);
    }
    beginRollSound(duration) {
      this.stopSounds();
      if (!this.soundGesture || !this.config.soundEnabled || this.soundMuted || !this.isConnected || document.hidden) return;
      const context = this.openSoundContext();
      this.soundGesture = null;
      if (!context) return;
      const seconds = Math.max(0, Number(duration) || 0);
      const session = {
        generation: this.soundGeneration, context, phase: 'rolling',
        deadline: performance.now() + seconds * 1000, resultPromise: null
      };
      this.soundSession = session;
      const ready = this.soundContextReady;
      session.resultPromise = Promise.all([ready, this.loadSoundBuffer(this.config.resultSoundUrl, context)])
        .then(([running, buffer]) => running ? buffer : null).catch(() => null);
      if (!seconds) return;
      Promise.all([ready, this.loadSoundBuffer(this.config.rollSoundUrl, context)]).then(([running, buffer]) => {
        if (!running || !buffer || !this.soundSessionValid(session) || session.phase !== 'rolling') return;
        const remaining = (session.deadline - performance.now()) / 1000;
        if (remaining > 0.025) this.playSoundBuffer(buffer, Math.min(remaining, buffer.duration), 'roll', session);
      }).catch(() => {});
    }
    finishRollSound() {
      const session = this.soundSession;
      if (!this.soundSessionValid(session) || session.phase !== 'rolling') return;
      session.phase = 'finished';
      const finishedAt = performance.now();
      this.stopSoundNodes('roll');
      session.resultPromise.then(buffer => {
        if (buffer && performance.now() - finishedAt <= 250 && this.soundSessionValid(session) && session.phase === 'finished') {
          this.playSoundBuffer(buffer, Math.min(buffer.duration, 2), 'result', session);
        }
      });
    }
    playSoundBuffer(buffer, duration, kind, session) {
      if (!this.soundSessionValid(session) || session.context.state !== 'running' || !(duration > 0)) return;
      const context = session.context;
      const volume = Number(this.config.soundVolume);
      const level = Math.max(0, Math.min(1, Number.isFinite(volume) ? volume : 0.6));
      if (!level) return;
      let source, gain, node;
      try {
        source = context.createBufferSource();
        gain = context.createGain();
        source.buffer = buffer;
        source.connect(gain);
        gain.connect(context.destination);
        const now = context.currentTime;
        const fade = Math.min(0.045, duration / 3);
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(level, now + Math.min(0.008, fade));
        gain.gain.setValueAtTime(level, now + duration - fade);
        gain.gain.linearRampToValueAtTime(0, now + duration);
        node = { source, gain, kind };
        this.soundNodes.add(node);
        source.onended = () => {
          this.soundNodes.delete(node);
          source.disconnect();
          gain.disconnect();
        };
        source.start(now, 0, duration);
      } catch (_) {
        if (node) this.soundNodes.delete(node);
        try { source?.disconnect(); gain?.disconnect(); } catch (_) {}
      }
    }
    stopSoundNodes(kind) {
      this.soundNodes?.forEach(node => {
        if (kind && node.kind !== kind) return;
        node.source.onended = null;
        try { node.source.stop(); } catch (_) {}
        try { node.source.disconnect(); node.gain.disconnect(); } catch (_) {}
        this.soundNodes.delete(node);
      });
    }
    stopSounds() {
      this.soundGeneration = (this.soundGeneration || 0) + 1;
      this.soundSession = null;
      this.stopSoundNodes();
    }
    disposeSound() {
      this.stopSounds();
      this.soundGesture = null;
      clearTimeout(this.soundGestureTimer);
      this.soundFetchController?.abort();
      this.soundFetchController = null;
      this.soundCache?.clear();
      const context = this.soundContext;
      this.soundContext = null;
      this.soundContextReady = null;
      if (context && context.state !== 'closed') {
        try { Promise.resolve(context.close()).catch(() => {}); } catch (_) {}
      }
    }
    setupVideo(signal) {
      this.dialog = this.querySelector('.okds-dialog');
      this.video = this.querySelector('[data-gesture-video]');
      const opener = this.querySelector('[data-open-video]');
      if (!this.dialog || !this.video || !opener || typeof this.dialog.showModal !== 'function') return;
      const status = this.querySelector('[data-video-error]');
      opener.addEventListener('click', event => {
        event.preventDefault();
        status.hidden = true;
        this.dialog.showModal();
        this.video.play().then(() => {
          if (!this.isConnected || !this.dialog.open) this.video.pause();
        }).catch(() => { if (this.isConnected && this.dialog.open) status.hidden = false; });
      }, { signal });
      this.querySelector('[data-close-video]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('close', () => {
        this.video.pause();
        if (this.video.readyState > 0) this.video.currentTime = 0;
        if (opener.isConnected) opener.focus({ preventScroll: true });
      }, { signal });
      this.video.addEventListener('error', () => { status.hidden = false; }, { signal });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-discovery-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-discovery-cards')) {
  customElements.define('okd-discovery-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const cards = Array.from(this.querySelectorAll('[data-okdc-card]'));
      cards.forEach(card => {
        const reset = () => { ['--rx', '--ry', '--lift'].forEach(key => card.style.removeProperty(key)); };
        const move = event => {
          if (this.dataset.motion !== 'true' || this.reduced.matches || event.target.closest('video')) return;
          const box = card.getBoundingClientRect();
          const x = Math.max(0, Math.min(1, (event.clientX - box.left) / box.width));
          const y = Math.max(0, Math.min(1, (event.clientY - box.top) / box.height));
          card.style.setProperty('--rx', `${(0.5 - y) * 5}deg`);
          card.style.setProperty('--ry', `${(x - 0.5) * 5}deg`);
          card.style.setProperty('--lift', '-3px');
        };
        card.addEventListener('pointermove', move, {signal, passive:true});
        card.addEventListener('pointerdown', move, {signal, passive:true});
        ['pointerleave', 'pointerup', 'pointercancel'].forEach(type => card.addEventListener(type, reset, {signal, passive:true}));
        this.reduced.addEventListener('change', reset, {signal});
      });
      this.autoVideos = cards.filter(card => card.querySelector('[data-okdc-autoplay]')).map(card => card.querySelector('video')).filter(Boolean);
      this.pausedByUser = new WeakSet();
      this.inView = new WeakSet();
      this.autoVideos.forEach(video => {
        video.addEventListener('pointerdown', () => this.pausedByUser.add(video), {signal, passive:true});
        video.addEventListener('keydown', () => this.pausedByUser.add(video), {signal});
      });
      this.syncVideos = () => this.autoVideos.forEach(video => {
        if (document.hidden || this.reduced.matches || !this.inView.has(video)) video.pause();
        else if (!this.pausedByUser.has(video)) { video.muted = true; video.play().catch(() => {}); }
      });
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.isIntersecting ? this.inView.add(entry.target) : this.inView.delete(entry.target));
          this.syncVideos();
        }, {threshold:0.25});
        this.autoVideos.forEach(video => this.videoObserver.observe(video));
      }
      this.reduced.addEventListener('change', this.syncVideos, {signal});
      document.addEventListener('visibilitychange', this.syncVideos, {signal});
    }
    disconnectedCallback() {
      this.videoObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-hero-essential"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-hero-essential')) {
  customElements.define('okd-hero-essential', class extends HTMLElement {
    connectedCallback() {
      this.disconnectHero();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('[data-hero-video]');
      this.toggle = this.querySelector('[data-motion-toggle]');
      if (!this.video || !this.toggle) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.connection = navigator.connection;
      this.inView = false;
      this.manualPlay = false;
      this.manualPause = false;
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) { this.manualPlay = true; this.manualPause = false; this.syncPlayback(); }
        else { this.manualPause = true; this.manualPlay = false; this.video.pause(); }
      }, { signal });
      this.video.addEventListener('playing', () => { this.video.classList.add('is-playing'); this.syncToggle(); }, { signal });
      this.video.addEventListener('pause', () => this.syncToggle(), { signal });
      this.video.addEventListener('ended', () => { this.manualPause = true; this.syncToggle(); }, { signal });
      this.video.addEventListener('error', () => { this.video.classList.remove('is-playing'); this.syncToggle(); }, { signal });
      this.reduced.addEventListener('change', () => { this.manualPlay = false; this.syncPlayback(); }, { signal });
      this.mobile.addEventListener('change', () => { this.video.pause(); this.video.classList.remove('is-playing'); this.video.removeAttribute('src'); this.video.load(); this.syncPlayback(); }, { signal });
      this.connection?.addEventListener('change', () => this.syncPlayback(), { signal });
      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.disconnectHero(), { signal });
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.syncPlayback(); }, { threshold: .05 });
      this.observer.observe(this);
      this.syncToggle();
    }
    syncPlayback() {
      if (!this.video) return;
      const mayAutoplay = this.dataset.autoplay === 'true' && !this.reduced.matches && !this.connection?.saveData;
      if (!this.inView || document.hidden || this.manualPause || (!this.manualPlay && !mayAutoplay)) { this.video.pause(); return; }
      const src = this.mobile.matches ? this.video.dataset.mobile : this.video.dataset.desktop;
      if (!src) return;
      if (this.video.getAttribute('src') !== src) { this.video.src = src; this.video.load(); }
      this.video.muted = true;
      this.video.play().catch(() => this.syncToggle());
    }
    syncToggle() {
      if (!this.video || !this.toggle) return;
      const playing = !this.video.paused && !this.video.ended;
      const label = playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel;
      this.toggle.querySelector('[data-motion-icon]').textContent = playing ? 'Ⅱ' : '▶';
      this.toggle.querySelector('[data-motion-label]').textContent = label;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.setAttribute('aria-pressed', String(playing));
    }
    disconnectHero() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
    disconnectedCallback() { this.disconnectHero(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-home-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-home-discovery')) {
  customElements.define('okd-home-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.dataset.chapter !== 'discovery') return;
      const config = this.querySelector('[data-home-config]');
      if (!config) return;
      this.config = JSON.parse(config.textContent);
      this.ready = true;
      this.setupVideo();
      this.setupCinema();
      this.activeDie = 0;
      this.rollButton = this.querySelector('[data-roll]');
      this.faceImage = this.querySelector('[data-die-image]');
      this.resultText = this.querySelector('[data-result]');
      this.resultNote = this.querySelector('[data-result-note]');
      this.scenarioButtons = [...this.querySelectorAll('[data-scenario]')];
      this.querySelector('.okh-scenarios').hidden = false;
      this.rollButton.hidden = false;
      this.scenarioButtons.forEach(button => button.addEventListener('click', () => this.choose(Number(button.dataset.scenario))));
      this.rollButton.addEventListener('click', () => this.roll());
    }
    disconnectedCallback() {
      clearTimeout(this.rollTimer);
      if (this.cinemaCleanup) this.cinemaCleanup();
      if (this.gestureVideo) this.gestureVideo.pause();
      if (this.videoDialog && this.videoDialog.open) this.videoDialog.close();
      if (this.rollButton) this.rollButton.disabled = false;
      if (this.faceImage) this.faceImage.classList.remove('is-rolling');
    }
    setupCinema() {
      const video = this.querySelector('[data-cinema-video]');
      const button = this.querySelector('[data-cinema-toggle]');
      if (!video || !button) return;
      const label = button.querySelector('[data-cinema-label]');
      const icon = button.querySelector('[data-cinema-icon]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let manuallyPaused = false;
      let inView = true;
      let alive = true;
      const update = () => {
        label.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        icon.textContent = video.paused ? '▶' : 'Ⅱ';
      };
      const play = () => {
        if (!video.src) video.src = matchMedia('(max-width: 749px)').matches ? video.dataset.mobile : video.dataset.desktop;
        video.muted = true;
        video.play().then(() => { if (!alive || document.hidden || !inView) video.pause(); }).catch(update);
      };
      video.addEventListener('playing', () => { video.classList.add('is-playing'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { video.classList.remove('is-playing'); button.hidden = true; });
      button.hidden = false;
      button.addEventListener('click', () => {
        if (video.paused) { manuallyPaused = false; play(); }
        else { manuallyPaused = true; video.pause(); }
      });
      const sync = () => {
        if (document.hidden || !inView || reduced.matches || manuallyPaused) video.pause();
        else play();
      };
      const motionChanged = () => { manuallyPaused = reduced.matches; sync(); };
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', motionChanged);
      const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); }, {threshold: 0.05});
      observer.observe(this.querySelector('.okc-cinema'));
      if (!reduced.matches && !navigator.connection?.saveData) play();
      else manuallyPaused = true;
      this.cinemaCleanup = () => {
        alive = false;
        video.pause();
        observer.disconnect();
        document.removeEventListener('visibilitychange', sync);
        reduced.removeEventListener('change', motionChanged);
      };
    }
    setupVideo() {
      this.videoDialog = this.querySelector('.okh-video-dialog');
      this.gestureVideo = this.querySelector('[data-gesture-video]');
      this.videoOpener = this.querySelector('[data-open-video]');
      if (!this.videoDialog || !this.gestureVideo || !this.videoOpener || typeof this.videoDialog.showModal !== 'function') return;
      const status = this.querySelector('.okh-video-status');
      this.videoOpener.addEventListener('click', event => {
        event.preventDefault();
        status.hidden = true;
        this.videoDialog.showModal();
        this.gestureVideo.play().then(() => {
          if (!this.videoDialog.open) this.gestureVideo.pause();
        }).catch(() => {
          if (this.videoDialog.open) status.hidden = false;
        });
      });
      this.querySelector('[data-close-video]').addEventListener('click', () => this.videoDialog.close());
      this.videoDialog.addEventListener('click', event => {
        if (event.target === this.videoDialog) this.videoDialog.close();
      });
      this.videoDialog.addEventListener('close', () => {
        this.gestureVideo.pause();
        if (this.gestureVideo.readyState > 0) this.gestureVideo.currentTime = 0;
        if (this.videoOpener.isConnected) this.videoOpener.focus({preventScroll: true});
      });
      this.gestureVideo.addEventListener('error', () => { status.hidden = false; });
    }
    choose(index) {
      clearTimeout(this.rollTimer);
      this.activeDie = index;
      const die = this.config.dice[index];
      this.scenarioButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      this.querySelector('[data-die-name]').textContent = die.name;
      this.querySelector('[data-question]').innerHTML = die.question;
      this.querySelector('[data-explanation]').textContent = die.explanation;
      this.faceImage.src = die.faces[0].image;
      this.faceImage.alt = die.faces[0].name;
      this.faceImage.classList.remove('is-rolling');
      this.resultText.textContent = this.config.ready;
      this.resultNote.textContent = this.config.readyNote;
      this.rollButton.firstChild.textContent = this.config.roll;
      this.rollButton.disabled = false;
    }
    roll() {
      if (this.rollButton.disabled) return;
      const die = this.config.dice[this.activeDie];
      const face = die.faces[Math.floor(Math.random() * die.faces.length)];
      this.rollButton.disabled = true;
      this.rollButton.firstChild.textContent = this.config.rolling;
      this.faceImage.classList.add('is-rolling');
      this.rollTimer = setTimeout(() => {
        this.faceImage.src = face.image;
        this.faceImage.alt = face.name;
        this.faceImage.classList.remove('is-rolling');
        this.resultText.textContent = face.name;
        this.resultNote.textContent = die.note;
        this.rollButton.firstChild.textContent = this.config.again;
        this.rollButton.disabled = false;
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 550);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-notice-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okey-notice')) {
  customElements.define('okey-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const video = this.querySelector('.okn-video');
      const videoToggle = this.querySelector('[data-video-toggle]');
      if (video && videoToggle) {
        videoToggle.hidden = false;
        const updateVideo = () => {
          const playing = !video.paused && !video.ended;
          videoToggle.setAttribute('aria-label', playing ? videoToggle.dataset.pauseLabel : videoToggle.dataset.playLabel);
          videoToggle.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
        };
        videoToggle.addEventListener('click', () => {
          if (!video.paused && !video.ended) video.pause();
          else video.play().catch(() => video.focus());
        }, { signal });
        ['play', 'pause', 'ended', 'error'].forEach(event => video.addEventListener(event, updateVideo, { signal }));
      }
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      const list = this.querySelector('[data-tabs]');
      if (!list || this.tabs.length !== this.panels.length) return;
      list.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        const panel = this.panels[index];
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.select(index);
          history.replaceState(null, '', '#' + panel.id);
        }, { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); tab.click(); return; }
          else return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
          history.replaceState(null, '', '#' + this.panels[next].id);
        }, { signal });
      });
      const fromHash = () => {
        const index = this.panels.findIndex(panel => '#' + panel.id === location.hash);
        if (index >= 0) this.select(index);
      };
      this.select(Math.max(0, this.panels.findIndex(panel => '#' + panel.id === location.hash)));
      this.setAttribute('data-enhanced', '');
      window.addEventListener('hashchange', fromHash, { signal });
      window.addEventListener('popstate', fromHash, { signal });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
        this.panels[i].hidden = i !== index;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-product-story')) {
customElements.define('okd-product-story', class extends HTMLElement {
  connectedCallback() {
    if(this.ready) return;
    this.ready=true;
    const video=this.querySelector('video'),play=this.querySelector('.okp-play');
    if(!video||!play) return;
    play.hidden=false;
    play.addEventListener('click',()=>{play.hidden=true;video.play().then(()=>video.focus()).catch(()=>{play.hidden=false;});});
    video.addEventListener('play',()=>{play.hidden=true;});
    video.addEventListener('ended',()=>{play.hidden=false;});
    this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting&&!video.paused)video.pause();},{threshold:0});
    this.observer.observe(video);
  }
  disconnectedCallback(){this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okd-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('okd-review-carousel')) {
  customElements.define('okd-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.okdr-list');
      this.cards = [...this.querySelectorAll('.okdr-card')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.controls = this.querySelector('.okdr-controls');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.positions = [0];
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        this.sync();
        clearTimeout(this.announcement);
        this.announcement = setTimeout(() => this.announce(), 180);
      }, { signal, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        let target;
        if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.positions.length - 1;
        else if (event.key === 'ArrowRight') target = this.index() + (this.rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') target = this.index() + (this.rtl ? 1 : -1);
        else return;
        event.preventDefault();
        this.go(target);
      }, { signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !this.overflow || event.target.closest('a, button, video, input, select, textarea')) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: this.logicalScroll, active: false };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.active) {
          if (Math.abs(delta) < 6 || Math.abs(delta) < Math.abs(event.clientY - this.drag.y)) return;
          this.drag.active = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }
        event.preventDefault();
        this.track.scrollLeft = (this.drag.scroll - delta * (this.rtl ? -1 : 1)) * (this.rtl ? -1 : 1);
      }, { signal });
      const endDrag = () => {
        if (!this.drag) return;
        const { active, id } = this.drag;
        this.drag = null;
        if (this.track.hasPointerCapture(id)) this.track.releasePointerCapture(id);
        this.track.classList.remove('is-dragging');
        if (active) this.go(this.index());
      };
      this.track.addEventListener('pointerup', endDrag, { signal });
      this.track.addEventListener('pointercancel', endDrag, { signal });
      this.track.addEventListener('lostpointercapture', endDrag, { signal });
      this.track.addEventListener('pointerleave', () => { if (this.drag && !this.drag.active) this.drag = null; }, { signal });
      this.track.addEventListener('dragstart', event => { if (event.target.closest('img')) event.preventDefault(); }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.reviewId === event.detail?.blockId || item === event.target || item.contains(event.target));
        if (card) this.scrollToOffset(this.cardOffset(card), true);
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(schedule);
        this.resize.observe(this.track);
      } else window.addEventListener('resize', schedule, { signal });
      this.dataset.ready = '';
      this.measure();
    }
    get logicalScroll() { return this.track.scrollLeft * (this.rtl ? -1 : 1); }
    cardOffset(card) {
      const track = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      return this.logicalScroll + (this.rtl ? track.right - rect.right : rect.left - track.left);
    }
    measure() {
      this.track.toggleAttribute('data-overflow', this.cards.length > 1);
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.overflow = this.maximum > 2;
      this.track.toggleAttribute('data-overflow', this.overflow);
      this.controls.hidden = !this.overflow;
      this.positions = [0];
      if (this.overflow) {
        this.cards.forEach(card => {
          const offset = Math.min(this.maximum, Math.max(0, this.cardOffset(card)));
          if (offset > this.positions[this.positions.length - 1] + 2) this.positions.push(offset);
        });
      }
      this.querySelector('[data-pages]').textContent = this.positions.length;
      this.sync();
    }
    index() {
      return this.positions.reduce((best, position, index) => Math.abs(position - this.logicalScroll) < Math.abs(this.positions[best] - this.logicalScroll) ? index : best, 0);
    }
    sync() {
      this.previous.disabled = this.logicalScroll < 2;
      this.next.disabled = this.logicalScroll >= this.maximum - 2;
      const index = this.index();
      this.querySelector('[data-page]').textContent = index + 1;
      this.style.setProperty('--review-progress', `${(index + 1) / this.positions.length * 100}%`);
    }
    announce() {
      this.querySelector('[data-status]').textContent = this.dataset.positionLabel.replace('[current]', this.index() + 1).replace('[total]', this.positions.length);
    }
    move(direction) { this.go(this.index() + direction); }
    go(index) {
      const bounded = Math.max(0, Math.min(this.positions.length - 1, index));
      this.scrollToOffset(this.positions[bounded]);
    }
    scrollToOffset(offset, immediate = false) {
      this.track.scrollTo({ left: Math.max(0, Math.min(this.maximum, offset)) * (this.rtl ? -1 : 1), behavior: immediate || this.reduced.matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.announcement);
      this.abort = null;
      this.drag = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
